export default {
    namespaced: true,
    state: {
        feedbackFormData: {
            feedbackType: null,
            feedbackText: '',
            feedbackImages: [],
            contact: ''
        }
    },
    mutations: {
        SET_FEEDBACK_FORM_DATA: (state, val) => {
            state.feedbackFormData = val;
        },
        RESET_FEEDBACK_FORM_DATA: state => {
            state.feedbackFormData = {
                feedbackType: null,
                feedbackText: '',
                feedbackImages: [],
                contact: ''
            };
        }
    },
    actions: {
        setFeedbackFormData({commit}, data) {
            commit('SET_FEEDBACK_FORM_DATA', data);
        },
        resetFeedbackFormData({commit}, data) {
            commit('RESET_FEEDBACK_FORM_DATA', data);
        },
        async submitFeedback({commit, state}, {model, formData}) {
            try {
                const {feedbackImages, ...rest} = formData;
                const promiseArr = feedbackImages.map(src =>
                    model.feedback.addBase64Image({base64: src})
                );
                const imgs = await Promise.all(promiseArr);
                const params = {
                    ...rest,
                    feedbackImages: imgs
                };
                const res = await model.feedback.addFeedback(params);
                return res;
            }
            catch (err) {
                return Promise.reject(err);
            }
        }
    }
};